import { Link } from 'react-router-dom';
import Reveal from '@/components/apple/Reveal';
import { foto, img } from '@/lib/projetos';
import { Container, SectionTitle } from '@/components/apple/ui';

const SOLUCOES = [
  {
    titulo: 'Cadeiras corporativas',
    texto: 'Operação, diretoria, recepção, reunião e auditório. Até 5 anos de garantia.',
    to: '/cadeiras',
    foto: foto(22, 0),
    alt: 'Cadeiras ergonômicas na sala de reuniões da RodoNorte, em Caruaru',
  },
  {
    titulo: 'Escritórios e empresas',
    texto: 'Estações de trabalho, salas de reunião, diretoria e armazenamento.',
    to: '/segmentos',
    foto: foto(1, 2),
    alt: 'Sala de diretoria do escritório Statregi Contabilidade em Caruaru',
  },
  {
    titulo: 'Clínicas e saúde',
    texto: 'Recepção, espera e consultórios com conforto e circulação.',
    to: '/clinicas',
    foto: foto(2, 0),
    alt: 'Sala de espera com longarinas em clínica de Bonito, Pernambuco',
  },
  {
    titulo: 'Órgãos públicos',
    texto: 'Plenários, gabinetes e secretarias, com documentação para compras públicas.',
    to: '/fornecimento-orgaos-publicos',
    foto: foto(4, 0),
    alt: 'Plenário da Câmara de Vereadores de Santa Cruz do Capibaribe',
  },
];

const EXTRAS = [
  { label: 'Mesas', to: '/mesas' },
  { label: 'Móveis de aço', to: '/aco' },
  { label: 'Divisórias', to: '/divisorias' },
  { label: 'Cabines acústicas', to: '/cabines-acusticas' },
  { label: 'Marcenaria', to: '/marcenaria' },
  { label: 'Escolas', to: '/escolar' },
  { label: 'Igrejas', to: '/igrejas' },
];

export default function Solucoes() {
  return (
    <section className="bg-[#F5F5F7] py-24 md:py-36">
      <Container>
        <Reveal>
          <SectionTitle
            eyebrow="Soluções"
            title="Para cada tipo de ambiente."
            sub="Primeiro entendemos o uso, o espaço e o investimento. Depois indicamos o produto certo."
          />
        </Reveal>

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {SOLUCOES.map((s, i) => (
            <Reveal key={s.to} delay={((i % 2) + 1) as 1 | 2}>
              <Link to={s.to} className="group block bg-white rounded-[18px] md:rounded-[24px] overflow-hidden h-full">
                <div className="overflow-hidden">
                  <img
                    src={img(s.foto, 1100)}
                    alt={s.alt}
                    loading="lazy"
                    decoding="async"
                    className="w-full aspect-[3/2] object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]"
                  />
                </div>
                <div className="p-6 md:p-8">
                  <h3 className="text-[22px] md:text-[28px] font-semibold tracking-[-0.03em] text-[#1D1D1F]">{s.titulo}</h3>
                  <p className="mt-2 text-[15px] md:text-[17px] leading-[1.45] text-[#6E6E73]">{s.texto}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-[15px] md:text-[17px] text-[#C4500A] group-hover:underline underline-offset-4">
                    Saiba mais <span aria-hidden="true">›</span>
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-2">
          {EXTRAS.map((e) => (
            <Link
              key={e.to}
              to={e.to}
              className="text-[14px] text-[#1D1D1F] bg-white px-4 py-2 rounded-full hover:bg-[#1D1D1F] hover:text-white"
            >
              {e.label}
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
}
